module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><defs><style>.a{fill:#0061a5;}</style></defs><title>41-Award-A</title><path class=\"a\" d=\"M21,3H17.7A2,2,0,0,0,16,2H8A2,2,0,0,0,6.3,3H3A1,1,0,0,0,2,4V7A3,3,0,0,0,3.1,9.4l4.2,3.3A6,6,0,0,0,11,14.9V17H9a1,1,0,0,0-1,1v2H7v2H17V20H16V18a1,1,0,0,0-1-1H13V14.9a6,6,0,0,0,3.7-2.2l4.2-3.3A3,3,0,0,0,22,7V4A1,1,0,0,0,21,3ZM14,20H10V19h4ZM4.4,7.8A1,1,0,0,1,4,7V5H6V9H6ZM12,13A4,4,0,0,1,8,9V4h8V9A4,4,0,0,1,12,13Zm8-6a1,1,0,0,1-.4.8L18,9.1h0V5h2Z\" transform=\"translate(-2 -2)\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/award.svg
// module id = 780
// module chunks = 1